import { mainAssetKey } from "../../../stores/PlayerStore";
import type { IModModel } from "../../../stores/ModsStore";
import type { TimelineLayerInfo } from "./layerHierarchy";
import { modTypes } from "@blings/blings-player";
import { isAlive, isStateTreeNode } from "mobx-state-tree";

const TIMING_CUSTOM_MOD_PATHS = new Set(["ip", "op", "st"]);

export const normalizeAssetId = (
  assetId: string | undefined
): string | undefined => {
  if (!assetId || assetId === mainAssetKey) return undefined;
  return assetId;
};

export function isReadableMod(
  mod: IModModel | null | undefined
): mod is IModModel {
  return Boolean(mod && (!isStateTreeNode(mod) || isAlive(mod)));
}

export const modTargetsLayer = (
  mod: IModModel,
  layer: TimelineLayerInfo
): boolean => {
  const modData = mod.moddata;

  if (typeof layer.uid === "number") {
    return modData.layerUid === layer.uid;
  }

  if (modData.layerName !== layer.nm) return false;
  return normalizeAssetId(modData.assetId) === normalizeAssetId(layer.assetId);
};

export const getLayerTimingCustomMods = (
  mods: IModModel[],
  layer: TimelineLayerInfo
): IModModel[] =>
  mods.filter((mod) => {
    if (!isReadableMod(mod)) return false;
    if (mod.moddata.type !== modTypes.custom) return false;
    if (mod.moddata.isDisabled) return false;
    if (!TIMING_CUSTOM_MOD_PATHS.has(mod.moddata.path ?? "")) return false;
    return modTargetsLayer(mod, layer);
  });
